
export const USLacrosseMember: Record<string, string>= {
    username: "clublacrosse_test",
    password: "Xc57p0&^Sxp^qJU0",
    client_id: "50e35de2-1432-4512-8276-983fc643112b",
    secret: "8a17da9d2467104b779cd3b66b0685bdfc60a4eb5ced5bbef39b565e5746925f",
    grant_type: "password"
}